// Shared ag-grid column definitions used across the Sales, Dashboard, and
// Shipping grids, so formatting stays consistent in one place.

// A Firestore timestamp date column with compact, responsive formatting:
//   desktop  -> short weekday + 2-digit year   (e.g. "Thu, 7/16/26")
//   < 768px  -> even tighter, no weekday        (e.g. "7/16/26")
// `field` is the timestamp field name (e.g. "sales_date" or "ship_date").
export function dateColumn(field, headerName) {
  return {
    field,
    headerName,
    flex: 0,
    width: 122,
    minWidth: 88,
    valueGetter(params) {
      const ts = params.data[field];
      if (!(ts?.seconds > 0)) return undefined;
      const d = new Date(ts.seconds * 1000);
      if (window.innerWidth < 768) {
        return d.toLocaleDateString("en", {
          month: "numeric",
          day: "numeric",
          year: "2-digit",
        });
      }
      return d.toLocaleString("en", {
        weekday: "short",
        year: "2-digit",
        month: "numeric",
        day: "numeric",
      });
    },
    // Sort by the timestamp, tie-breaking on creation time. Rows missing the
    // date sort to the bottom (ascending) as before.
    comparator(valueA, valueB, nodeA, nodeB) {
      const a = nodeA.data[field]?.seconds;
      const b = nodeB.data[field]?.seconds;
      if (!a && !b) return 0;
      if (!a) return -1;
      if (!b) return 1;
      if (a === b) {
        return (nodeA.data.created?.seconds || 0) - (nodeB.data.created?.seconds || 0);
      }
      return a - b;
    },
  };
}
